<div class="change-password">
  <div class="container"
       style="display: flex; flex-direction: row; gap: 60px; justify-content: center"
>
    <div style="display: flex; flex-direction: column; flex: 50%; gap: 10px; justify-content: center"
>
      <mat-card class="">
        <mat-card-title>
          <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif;" class="text-left">Select new password</h2>
        </mat-card-title>
        <div *ngIf="msg" role="alert" class="alert alert-error alert-dismissible">
          <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
          <span class="sr-only">Error:</span>
          {{msg}}
        </div>
        <mat-card-content>
          <div class="editUser" *ngIf='user != null'>
            <div class="explanation text-left">Please choose a new password that meets the rules below
            </div>
            <div style="display: flex; flex-direction: row;">
              <div style="flex:50%">
            <form class="example-form">
              <mat-form-field class="example-full-width">
                <mat-label>Old password</mat-label>
                <input matInput
                       type="password"

                       name="password"
                       [(ngModel)]="oldPassword">
              </mat-form-field>
            </form>

            <form class="example-form">
              <mat-form-field class="example-full-width">
                <mat-label>New password</mat-label>
                <input matInput
                       type="password"

                       name="newPassword"
                       [(ngModel)]="newPassword">
              </mat-form-field>
            </form>

            <form class="example-form">
              <mat-form-field class="example-full-width">
                <mat-label>Re-enter new password</mat-label>
                <input matInput
                       type="password"

                       name="confirmationPassword"
                       [(ngModel)]="confirmationPassword">
              </mat-form-field>
            </form>
            <div style="padding-right: 16px;">
              <password-strength-meter [password]="newPassword" [enableFeedback]="false" [minPasswordLength]="12"></password-strength-meter>
            </div>
            </div>
              <div style="flex:50%">
                <div class="shadow">
                  <h4>Password Rules</h4>
                  <div style="display: flex; flex-direction: row;">
                    <i class="fa" [ngClass]="{'fa-check' : isSizeValid(), 'fa-close': !isSizeValid()}"></i>
                    <span>Must be 8-64 characters</span>
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <i class="fa" [ngClass]="{'fa-check' : isLetterValid(), 'fa-close': !isLetterValid()}"></i>
                    <span>Must have at least one letter</span>
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <i class="fa" [ngClass]="{'fa-check' : isNumberValid(), 'fa-close': !isNumberValid()}"></i>
                    <span>Must have at least one number</span>
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <i class="fa" [ngClass]="{'fa-check' : isSymbolValid(), 'fa-close': !isSymbolValid()}"></i>
                    <span>Must have at least one special symbol</span>
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <i class="fa" [ngClass]="{'fa-check' : isCopyValid(), 'fa-close': !isCopyValid()}"></i>
                    <span>UserID and password are not the same</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <div>
            <!--alert></alert-->
            <button mat-raised-button [disabled]="loading" style="border-radius: 6px;" (click)="onChange()">Submit
            </button>
            <img *ngIf="loading"
                 src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
            <button mat-raised-button style="border-radius: 6px;" [routerLink]="['/']">Cancel</button>
          </div>
        </mat-card-actions>
      </mat-card>
    </div>
    <div style="flex:50%">
      <h2>Tips for choosing a secure password</h2>
      <div>
        <h3>Here's a simple process for choosing a password that is random enough to be secure, yet still memorable:</h3>
        <ol>
          <li>
            Avoid words, phrases, or numbers easily associated with you (ex: birthday, child's or pet's name)
          </li>
          <li>
            Select a longer password for more security (Note: Quicken users may be associated with passwords longer than 32 characters)
          </li>
          <li>
            Include special characters (ex.: @, #, $, %), if desired
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
